import angular from "angular";
import Vue from "vue";
import "ngVue";

import StorefrontNavCategories from "./StorefrontNavCategories.vue";

export default angular
  .module("directives.storefrontnavcategories", [])
  .directive("dcStorefrontNavCategories", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("DcStorefrontNavCategories", StorefrontNavCategories),
      );
    },
  ]);
